import React from 'react';
import { Col, Form, FormGroup, Label, Input, ModalBody, Row, FormFeedback, ModalFooter, Button } from "reactstrap";

export const FormMicCatalogs = (props) => {
    const {
        closeDialog, loading, handleInputChange, name,description,estatus, methodAction,button
    } = props;

 

    
    return (
        <Form className='' role="form" onSubmit={methodAction}>
           
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className='label-admision'>Nombre<span className='f-16' style={{color:"#0079C7"}}>*</span></Label>
                        <Input 
                            className='input-admision'
                            type='text'
                            name="name"
                            onChange={handleInputChange}
                            value={name}
                            autoComplete="off"
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="8">
                    <FormGroup>
                        <Label className='label-admision'>Descripción <span className='f-16' style={{color:"#0079C7"}}>*</span></Label>
                        <Input 
                            className='input-admision'
                            type='text'
                            name="description"
                            onChange={handleInputChange}
                            value={description}
                            autoComplete="off"
                        />
                        <FormFeedback>Minimo 2 caracteres</FormFeedback>
                    </FormGroup>
                </Col>
                <Col md="4">
                <FormGroup>
                        <Label className=" mt-2">¿Activar Norma? </Label>
                        
                        <Label className="switch">
                            <Input type="checkbox" name="estatus" onChange={handleInputChange} checked={estatus} />
                            <span className="slider round"></span>
                        </Label>
                    </FormGroup>
                </Col>
            </Row>
           
            <ModalFooter>
                <Button color="primary" type="submit" size='sm' className={loading ? "disabled progress-bar-animated progresss-bar-striped":""}>
                    {button}
                </Button>
                <Button size="sm" color='danger' type='button' onClick={closeDialog}>
                    Cancelar
                </Button>
            </ModalFooter>
        </Form>
    )
}